import { inject, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { Match } from '../../_shared/models/match.model';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
    providedIn: 'root'
})
export class SocketService {

    constructor(
        private socket: Socket
    ) { }

    getSocketUpdate(name: string): Observable<unknown> {
        const observable = new Observable(observer => {
            this.socket.on(name, data => {
                observer.next(data);
            });
        });

        return observable;
    }

    joinRoom(room: string) {
        this.socket.emit('join-room', room);
    }

    leaveRoomAndRemoveSocketListener(room: string) {
        this.socket.emit('leave-room', room);
        this.socket.removeAllListeners(room)
    }

    async updateMatch(match: Match) {
        let deviceId = (await Preferences.get({ key: 'deviceId' }))?.value;
        this.socket.emit('update-match', {matchUp: match, deviceId: deviceId});
    }

    connectionStatus() {
        this.socket.on('disconnect', (error) => {
            // reconnect if disconnected code is creating issues when reconnecting 
            // socket which was disconnects due to app goes to background
            if(Capacitor.isNativePlatform()) return;
            this.socket.connect();
        })
    }
}
